import { HttpErrorResponse } from '@angular/common/http';
import { ErrorHandler, Injectable } from '@angular/core';
import { ConfigurationService } from '@app/shared/services/configuration.service';
import { AppMonitoringService } from '../services/app-monitoring.service';

@Injectable()
export class GlobalErrorHandler extends ErrorHandler {

  constructor(private configurationService: ConfigurationService, private monitoringService : AppMonitoringService) {
    super();
  }

  handleError(error: Error | HttpErrorResponse): void {
    const enableOriginalErrorHandler = this.configurationService.configuration.features.enableOriginalErrorHandler;
    if (enableOriginalErrorHandler) {
      super.handleError(error);
    }
    this.monitoringService.noticeError(error);
  }
}
